import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './maintain/independentPage/login/login.component';
import { EventComponent } from './event/event.component';


const routes: Routes = [
  { path: 'maintain/login', component: LoginComponent},
  { path: 'maintain', loadChildren: 'app/maintain/maintain.module#MaintainModule'},
  { path: 'tw', loadChildren: 'app/tw/tw.module#TwModule'},
  { path: 'event', component: EventComponent },
  { path: '**', redirectTo: 'tw'}
/*
  { path: 'event' ,component: EventComponent },
  { path: '**', component: EventComponent }*/
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts